export const __TEST__ = process.env.NODE_ENV === 'test';
